import React from "react";

import { Preview } from "./preview";
import { Props } from "./types";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";
import { Loader } from "@common/loader";

function Templates({
  templates,
  isRequestPending,
  selectedTemplate,
  setSelectedTemplate,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.templates}>
      <p className={styles.title}>{t("documentCreation.templates.title")}</p>
      {isRequestPending ? (
        <div className={styles.loader}>
          <div className={styles.loaderIcon}>
            <Loader />
          </div>
        </div>
      ) : (
        <div className={styles.list}>
          {templates.map((document, key) => (
            <div
              className={styles.templateBox}
              key={key}
              onClick={() => setSelectedTemplate(document)}
            >
              <Preview
                document={document}
                selectedDocument={selectedTemplate}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export { Templates };
